<template>
    <div v-html="content" :class="[css]"></div>  
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ""
    },
    css: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="stylus" scoped></style>
